/**
 * Vite entry for index.html: registers the level-transition globals and
 * starts the login/invite flow. The Babylon engine (main.js) is loaded
 * lazily by loginFlow when the user clicks Start.
 */
import './ui/levelTransition.js';
import { initLoginFlow } from './loginFlow.js';
import { initErrorReporter } from './services/errorReporter.js';

initErrorReporter();
initLoginFlow();
